<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'route']" />
        <span class="title">Routing</span>
      </Header>
      <v-row>
        <v-col class="col-6"
          ><b>Route status</b> <br />
          <br />Route status are determined by an algorithm after Saving the
          movement zones (see menu Settings -> Movement Zones).</v-col
        ></v-row
      >
      <v-row v-for="item in items" :key="item.id">
        <v-col class="col-5">
          <v-subheader>
            <b>{{ item.label }}</b>
          </v-subheader>
        </v-col>
        <v-col class="col-1">
          <v-subheader>{{ item.n }} objects</v-subheader>
        </v-col>
        <v-col class="col-3">
          <v-subheader>
            <router-link
              :to="{ name: 'settings_routing_test', params: { id: item.id } }"
              ><font-awesome-icon :icon="['fas', 'balance-scale']" /><span
                class="title"
                >Do test</span
              ></router-link
            >
          </v-subheader>
        </v-col>
        <v-col class="col-3">
          <input type="radio" id="accept" v-model="item.status" value="1" />
          <label for="twee">Accept routes</label><br />
          <input type="radio" id="judges" v-model="item.status" value="2" />
          <label for="een">Judges routes</label><br />
          <input type="radio" id="notraffic" v-model="item.status" value="3" />
          <label for="drie">No traffic participant</label>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="btn_update">Accept above settings</v-btn>
          <br /><br />
          Objects will not be deleted. Only the Route-status is set.
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
export default {
  data() {
    return {
      field: {},
      items: {}
    };
  },
  mounted() {
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "settings_routing"
    })
      .then(response => {
        this.items = response.data;
        //console.log(this.items);
      })
      .catch(error => {
        console.log("Fout " + error.response);
      });
  },
  components: {
    Header
  },
  methods: {
    btn_update() {
      console.log(this.items);
      let vars = this.items;
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "settings_route_update",
        vars
      });
    }
  }
};
</script>
<style scoped>
label {
  margin-left: 5px;
}
</style>
